import { createFileRoute } from '@tanstack/react-router'

import { IdentitySupport } from '@/containers/IdentitySupport'

export const Route = createFileRoute(
  '/_unauthenticated/setup/identity-support'
)({
  component: IdentitySupport,
})
